import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1bc7ec2c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc7ec2c')) {
      api.createRecord('1bc7ec2c', component.options)
    } else {
      api.reload('1bc7ec2c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1bc7ec2c&", function () {
      api.rerender('1bc7ec2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28mlcSIsPnIzh/JS/comp/ErrorMessage.vue"
export default component.exports